// extracted by mini-css-extract-plugin
export var active = "_lx-2";
export var recordingDot = "_lx-1";
export var recordingIndicator = "_lx-0";